module.exports = __webpack_public_path__ + "img/familyId@3x.5d8c7e70.png";